{
  "v7.projets.activite.quoi": "project activity",
  "v7.projets.activite.titre": "Project activity",
  "v7.projets.activite.vide": "No recent activity in the programme’s visible projects.",
  "v7.projets.annuler": "Cancel",
  "v7.projets.choisi.aucun": "Choose a project in the list to see its details.",
  "v7.projets.choisi.avancement": "Progress",
  "v7.projets.choisi.lance": "Launched",
  "v7.projets.choisi.lancement_inacheve": "Launch not finished: it continues in the project",
  "v7.projets.choisi.modele": "Model",
  "v7.projets.choisi.projet": "Project",
  "v7.projets.choisi.role": "Your role",
  "v7.projets.choisi.titre": "Selected project",
  "v7.projets.choisir": "Select",
  "v7.projets.code.CONFIRMATION_IDENTITE_ECHOUEE": "Wrong password: identity not confirmed.",
  "v7.projets.code.CONFIRMATION_IDENTITE_REQUISE": "A recent identity confirmation is required.",
  "v7.projets.code.CONTEXTE_INCOMPLET": "The programme context is incomplete: reload the page.",
  "v7.projets.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v7.projets.code.GARDE_DROIT_ABSENTE": "This action is not yet opened by the gateway.",
  "v7.projets.code.IDEMPOTENCY_KEY_CONFLICT": "This creation request was already sent with other values: reopen the dialog.",
  "v7.projets.code.INVALID_IDEMPOTENCY_KEY": "Invalid request key: reopen the dialog.",
  "v7.projets.code.NOT_FOUND": "Not found.",
  "v7.projets.code.PROGRAMME_A_DES_PROJETS": "This programme still has attached projects: detach them first.",
  "v7.projets.code.PROGRAMME_MODELE_NON_ADMIS": "This project model is not admitted by the programme model.",
  "v7.projets.code.PROGRAMME_NOM_DE_CONFIRMATION_DIFFERENT": "The name entered does not match the programme name.",
  "v7.projets.code.PROGRAMME_PROPOSITION_DEJA_EN_ATTENTE": "An attachment proposal for this project already awaits its owner’s decision.",
  "v7.projets.code.PROGRAMME_TRAITEMENT_ACTIF": "A programme job is running: wait for it to finish.",
  "v7.projets.code.PROGRAM_SETTINGS_CONFLICT": "The settings were changed meanwhile: reload them before saving.",
  "v7.projets.code.PROJECT_ALREADY_ATTACHED": "This project is already attached to another programme: detach it first.",
  "v7.projets.code.PROJECT_ATTACHED_ELSEWHERE": "This project is attached to another programme.",
  "v7.projets.code.PROJECT_OWNER_REQUIRED": "Only whoever governs this project (its owner) can attach or detach it.",
  "v7.projets.code.PROPOSITION_CADUQUE": "This proposal is already decided or withdrawn.",
  "v7.projets.code.PROPRIETAIRE_SEUL": "Reserved to the programme owner.",
  "v7.projets.code.REQUIREMENT_HAS_WAIVER_HISTORY": "A programme rule has a waiver history: the programme cannot be deleted.",
  "v7.projets.code.RESOURCE_UNAVAILABLE": "This programme cannot be found or is not open to you.",
  "v7.projets.code.SANS_SESSION": "Your session expired: sign in again.",
  "v7.projets.code.TEMPLATE_VERSION_NOT_PUBLISHED": "This model version is not published.",
  "v7.projets.code.VALIDATION_ERROR": "Input refused: check the fields.",
  "v7.projets.code.WORKSPACE_CREATION_CANCELLED": "This creation was cancelled: reopen the dialog.",
  "v7.projets.configuration.admis": "Admitted project models",
  "v7.projets.configuration.attente": "The choice opens once the settings and admitted models are read.",
  "v7.projets.configuration.aucun_propose": "No proposed model",
  "v7.projets.configuration.choix": "Model proposed to new projects",
  "v7.projets.configuration.choix_aide": "Chosen among the models admitted by the programme model; preselected when a project is created.",
  "v7.projets.configuration.enregistre": "Proposed model saved.",
  "v7.projets.configuration.enregistrer": "Save the proposed model",
  "v7.projets.configuration.fige": "Model frozen when the programme was created.",
  "v7.projets.configuration.modele": "Programme model",
  "v7.projets.configuration.modele_inconnu": "The programme model is unknown.",
  "v7.projets.configuration.modele_version": "{{id}}, version {{version}}",
  "v7.projets.configuration.propose": "Proposal to new projects",
  "v7.projets.configuration.propose_par_defaut": "proposed by default",
  "v7.projets.configuration.sans_liste": "The programme model does not restrict project models: every published model of the organisation is admitted.",
  "v7.projets.configuration.service": "Service commitment",
  "v7.projets.configuration.service_texte": "The programme model sets a service commitment for its projects’ continuous flow.",
  "v7.projets.configuration.titre": "Programme settings — configuration",
  "v7.projets.creer.creer": "Create the project",
  "v7.projets.creer.modele": "Project model",
  "v7.projets.creer.nom": "Project name",
  "v7.projets.creer.plus_tard": "Create and launch later",
  "v7.projets.creer.propriete": "You become its owner; you can transfer ownership to a member.",
  "v7.projets.creer.titre": "Create a project in the programme",
  "v7.projets.creer.version": "Model at its published version {{version}}, frozen in the project.",
  "v7.projets.creer_un_projet": "Create a project",
  "v7.projets.cycle.aucun_projet": "No attached project.",
  "v7.projets.cycle.detachez_d_abord": "Projects are attached to the programme: detach them first.",
  "v7.projets.cycle.etat": "Programme state",
  "v7.projets.cycle.gestes": "Ownership and deletion",
  "v7.projets.cycle.projets": "{{n}} attached projects ({{caches}} not visible).",
  "v7.projets.cycle.projets_one": "{{n}} attached project ({{caches}} not visible).",
  "v7.projets.cycle.quoi": "attached projects",
  "v7.projets.cycle.rattaches_en_lecture": "Reading attached projects: deletion waits until they are counted.",
  "v7.projets.cycle.rattaches_inconnus": "Attached projects could not be counted: deletion waits until they are.",
  "v7.projets.cycle.statut.active": "Active programme.",
  "v7.projets.cycle.statut.inactive": "Inactive programme.",
  "v7.projets.cycle.statut.suspended": "Suspended programme.",
  "v7.projets.cycle.titre": "Programme settings — lifecycle",
  "v7.projets.cycle.transferer": "Transfer ownership",
  "v7.projets.detacher": "Detach",
  "v7.projets.detacher.consequence.administration": "The programme loses downward administration of the project.",
  "v7.projets.detacher.consequence.figes": "Inherited technology choices are frozen as the project’s own choices.",
  "v7.projets.detacher.consequence.regles": "The programme’s rules and technologies stop applying to this project.",
  "v7.projets.detacher.effet.administration": "The programme no longer administers this project.",
  "v7.projets.detacher.effet.derogations": "{{n}} waivers lifted.",
  "v7.projets.detacher.effet.derogations_one": "{{n}} waiver lifted.",
  "v7.projets.detacher.effet.perimees": "{{n}} rules kept as outdated (waiver history).",
  "v7.projets.detacher.effet.perimees_one": "{{n}} rule kept as outdated (waiver history).",
  "v7.projets.detacher.effet.referentiel": "Inherited choices frozen in version {{version}} of the project baseline.",
  "v7.projets.detacher.effet.regles": "{{n}} inherited rules removed.",
  "v7.projets.detacher.effet.regles_one": "{{n}} inherited rule removed.",
  "v7.projets.detacher.succes": "Project detached from the programme.",
  "v7.projets.detacher.titre": "Detach “{{projet}}” from the programme?",
  "v7.projets.ecran_ulterieur": "The “{{ecran}}” screen is not open yet in this version.",
  "v7.projets.enregistrer": "Save",
  "v7.projets.etat.chargement": "Reading {{quoi}}…",
  "v7.projets.etat.en_cours": "In progress…",
  "v7.projets.etat.erreur": "Reading {{quoi}} failed.",
  "v7.projets.etat.introuvable": "Not found or not open: {{quoi}}.",
  "v7.projets.etat.reessayer": "Retry",
  "v7.projets.etat.refus": "Reading {{quoi}} refused.",
  "v7.projets.geste.erreur": "The action failed. Try again.",
  "v7.projets.liste.actions": "actions",
  "v7.projets.liste.etat": "state",
  "v7.projets.liste.legende": "Projects attached to the programme",
  "v7.projets.liste.modele": "model",
  "v7.projets.liste.modele_admis": "admitted by the programme",
  "v7.projets.liste.modele_non_admis": "not admitted by the programme",
  "v7.projets.liste.projet": "project",
  "v7.projets.liste.quoi": "the programme’s projects",
  "v7.projets.liste.sante": "health",
  "v7.projets.liste.sante_valeur": "{{approbations}} pending approvals, {{traitements}} jobs",
  "v7.projets.liste.titre": "Attached projects",
  "v7.projets.liste.vide": "No project is attached to this programme.",
  "v7.projets.modeles.aucun": "No admitted project model is published in the organisation.",
  "v7.projets.modeles.option_proposee": "{{nom}} (proposed by the programme)",
  "v7.projets.modeles.quoi": "the models admitted by the programme",
  "v7.projets.non_visibles": "{{n}} projects of the programme are not visible to you: they are counted without details.",
  "v7.projets.non_visibles_one": "{{n}} project of the programme is not visible to you: it is counted without details.",
  "v7.projets.onglet.configuration": "Configuration",
  "v7.projets.onglet.cycle": "Lifecycle",
  "v7.projets.onglet.identite": "Identity",
  "v7.projets.onglet.objectif": "Objective and register",
  "v7.projets.onglets": "Programme settings",
  "v7.projets.ouvrir": "Open",
  "v7.projets.ouvrir.non_membre": "You are not a member of this project.",
  "v7.projets.propositions.etat.caduque": "lapsed",
  "v7.projets.propositions.etat.en_attente": "awaiting its owner",
  "v7.projets.propositions.etat.refusee": "declined",
  "v7.projets.propositions.motif": "Reason: {{motif}}",
  "v7.projets.propositions.non_visible": "Project not visible",
  "v7.projets.propositions.quoi": "attachment proposals",
  "v7.projets.propositions.retiree": "Proposal withdrawn.",
  "v7.projets.propositions.retirer": "Withdraw",
  "v7.projets.propositions.retirer_nom": "Withdraw the proposal for {{projet}}",
  "v7.projets.propositions.titre": "Attachment proposals",
  "v7.projets.propositions.vide": "No attachment proposal.",
  "v7.projets.rattacher.aucun": "No other visible project of the organisation to attach.",
  "v7.projets.rattacher.aussitot": "You own this project: it will be attached right away.",
  "v7.projets.rattacher.choisir": "Choose a project",
  "v7.projets.rattacher.deja_ailleurs": "already attached to another programme",
  "v7.projets.rattacher.effet.administration": "The programme gains downward administration of the project.",
  "v7.projets.rattacher.effet.droits": "The programme’s profiles apply to the project; a more restricted project profile prevails.",
  "v7.projets.rattacher.effet.heritage": "Inheritance by category is kept.",
  "v7.projets.rattacher.effet.regles": "The programme’s rules and technologies apply to the project.",
  "v7.projets.rattacher.non_admis": "model not admitted by the programme",
  "v7.projets.rattacher.projet": "Project to attach",
  "v7.projets.rattacher.proposer": "Propose the attachment",
  "v7.projets.rattacher.proposition": "This project has another owner: a proposal will be sent, awaiting their agreement.",
  "v7.projets.rattacher.quoi": "the organisation’s projects",
  "v7.projets.rattacher.rattacher": "Attach",
  "v7.projets.rattacher.titre": "Attach a project to the programme",
  "v7.projets.rattacher_un_projet": "Attach a project",
  "v7.projets.reglages.description": "Description",
  "v7.projets.reglages.description_aide": "Optional.",
  "v7.projets.reglages.enregistres": "Settings saved.",
  "v7.projets.reglages.nom": "Programme name",
  "v7.projets.reglages.quoi": "the programme settings",
  "v7.projets.reglages.recharger": "Reload",
  "v7.projets.reglages.titre": "Programme settings — identity",
  "v7.projets.reglages.titre_section": "Identity",
  "v7.projets.role.aucun": "not a member",
  "v7.projets.role.contributor": "Contributor",
  "v7.projets.role.owner": "Owner",
  "v7.projets.role.viewer": "Viewer",
  "v7.projets.sans_programme": "Choose a programme first.",
  "v7.projets.statut.active": "active",
  "v7.projets.statut.archived": "archived",
  "v7.projets.supprimer.effet.journal": "Initiatives, register, choices and history are kept in the organisation’s log.",
  "v7.projets.supprimer.effet.projets": "The programme must no longer have any attached project.",
  "v7.projets.supprimer.effet.traitement": "No programme job may be running.",
  "v7.projets.supprimer.nom": "Programme name to retype",
  "v7.projets.supprimer.nom_aide": "Retype “{{nom}}” to confirm.",
  "v7.projets.supprimer.nom_different": "The name entered differs from the programme name.",
  "v7.projets.supprimer.secret": "Password (identity confirmation)",
  "v7.projets.supprimer.secret_aide": "Your password confirms your identity; it is not kept.",
  "v7.projets.supprimer.supprimer": "Delete the programme",
  "v7.projets.supprimer.titre": "Delete the programme — confirmation",
  "v7.projets.titre": "Programme projects",
  "v7.projets.validation.nom": "The name has 3 to 255 characters."
}
